<template>
  <div class="p-5 bg-white rounded non-print">
    <div class="py-6 text-xl text-center">{{ bookingType == 'daily' ? $t('booking.booking_daily') : bookingType == 'monthly' ? $t('booking.booking_monthly')
      : '-' }}</div>
    <between-date @onClick="initData"></between-date>
    <div class="flex justify-end py-3">
      <v-btn class="blue white--text mx-1" @click="exportExcel"
        :disabled="currentBookings.notCancelled.length == 0 && currentBookings.cancelled.length == 0">
        <v-icon left>mdi-file-excel</v-icon>Export Excel
      </v-btn>
      <v-btn class="blue white--text mx-1" @click="printPDF">
        <v-icon left>mdi-file-excel</v-icon>{{ $t('print_pdf') }}
      </v-btn>
      <FilterColumnDataTable v-model="headers" @onSuccess="onSelectFilterColumn" dataTableName="ReportBooking" />
    </div>
    <div id="printarea">
      <div v-for="(data, index) in currentBookings" :key="index">
        <div class="flex justify-center align-center" v-if="index == 'notCancelled'">
          <div class="payment-box bg-gray-100">{{ $t('booking.number_of_booking', {count: currentBookings[index].length || 0}) }}</div>
          <div class="payment-box bg-gray-100" v-if="bookingType == 'monthly'">{{ $t('booking.number_of_booking_success', {count: countBookingsSuccess || 0}) }}</div>
          <div class="payment-box bg-gray-100" v-if="bookingType == 'daily'">{{ $t('booking.number_of_stall_booked', {count: sumField(currentBookings[index], 'countAreaBookings') || 0}) }}</div>
          <div class="payment-box bg-gray-100" v-if="bookingType == 'daily'">{{ $t('area.number_stall_checked_in', {count: sumField(currentBookings[index], 'countCheckIn') || 0}) }}</div>
        </div>
        <div class="flex justify-center align-center" v-if="index == 'cancelled'">
          <div class="payment-box bg-gray-100">{{ $t('booking.booking_cancelled', {count: currentBookings[index].length || 0}) }}</div>
        </div>
        <div class="py-5">
          <h4>{{ $t('booking.booking_list_only') }}{{ index == 'cancelled' ? $t('cancelled') : '' }}</h4>
          <v-data-table
            :items-per-page="itemsPerPage"
            :headers="currentHeader"
            :items="currentBookings[index]"
            :loading="isLoading"
            class="elevation-1 v-data-table-report data-table-booking"
            :no-data-text="$t('booking.no_booking')"
            :no-results-text="$t('no_matching_records_found')">
           
            <template v-slot:header.areaNames="{header}"> 
              <div class="text-nowrap-table area-name" style="min-width:145px;">{{header.text}}</div>
            </template>
            <template v-slot:header.customerName="{header}">
              <div class="text-nowrap-table customer-name" style="min-width:145px;">{{header.text}}</div>
            </template>
            <template v-slot:header.businessName="{header}">
              <div class="text-nowrap-table business-name" style="min-width:145px;">{{header.text}}</div>
            </template>

            <template v-slot:item.areaNames="{ item }">
              <div class="text-truncate">{{ item.areaNames }}</div>
            </template>
            <template v-slot:item.createdAtFormat="{ item }">
              <div class="text-no-wrap">{{ item.createdAtFormat }}</div>
            </template>
            <template v-slot:item.customerName="{ item }">
              <div class="text-truncate">{{ item.customer ? item.customer.fullName : '-' }}</div>
            </template>
            <template v-slot:item.businessName="{ item }">
              <div class="text-truncate">{{ item.businessName }}</div>
            </template>

            <template v-slot:item.statusText="{ item }">
              <v-chip :color="item.statusColor">{{ item.statusText }}</v-chip>
              <v-chip :color="item.statusColor" v-if="item.contractSuspend">{{ $t('suspend.stall_in_suspend') }}</v-chip>
            </template>
            <template v-slot:item.sumTotalPaidValue="{ item }">
              <div class="text-no-wrap" :class="item.sumTotalPaidValue > 0 ? 'green--text' : ''">{{ item.sumTotalPaidValue | currencyPrefixSign }}</div>
            </template>
            <template v-slot:item.sumTotalUnpaidValue="{ item }">
              <div class="text-no-wrap" :class="item.sumTotalUnpaidValue > 0 ? 'red--text' : ''">{{ item.sumTotalUnpaidValue | currencyPrefixSign }}</div>
            </template>
            <template v-slot:item.countCheckIn="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on"
                    :class="item.countCheckIn == item.areaBookings.length ? 'green--text' : 'red--text'">
                    {{ item.countCheckIn }}/{{ item.areaBookings.length }}</div>
                </template>
                <span>{{ $t('area.number_of_stall_checked_in_summary') }}</span>
              </v-tooltip>
            </template>
            <template v-slot:item.sumTotalValue="{ item }">
              <div class="text-no-wrap">
                {{ item.sumTotalValue | currencyPrefixSign }}
              </div>
            </template>
            <template v-slot:item.detail="{ item }">
              <v-btn rounded small elevation="0" @click="clickDetail(item)">{{ $t('detail') }}</v-btn>
            </template>
          </v-data-table>
        </div>
        <div class="text-right">
          <div>{{ $t('booking.summary_booking', {action: index == 'cancelled' ? $t('cancel') : $t('payment.income')}) }}</div>
          <div class="green--text">{{ $t('payment.pay_only') }} {{ sumField(currentBookings[index], 'sumTotalPaidValue') | currencySuffixTextThEn }}</div>
          <div class="red--text">{{ $t('payment.pending') }} {{ sumField(currentBookings[index], 'sumTotalUnpaidValue') | currencySuffixTextThEn }}</div>
          <div>{{ $t('payment.total_price') }} {{ sumField(currentBookings[index], 'sumTotalValue') | currencySuffixTextThEn }}</div>
        </div>
      </div>
    </div>
    <BookingDialog v-model="detailDialog" :marketId="marketId" :projectId="projectId" :type="bookingType"
      :booking="currentBooking" @createBookingSuccess="createBookingSuccess" :isMainLoading="isLoading" />
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { ExportMarketReport } from "../exports";
import BetweenDate from "./BetweenDate.vue";
import BookingDialog from "./BookingDialog.vue";
import FilterColumnDataTable from "@/components/FilterColumnDataTable.vue"

export default {
  components: { BetweenDate, BookingDialog,FilterColumnDataTable },
  props: {
    bookingType: String
  },
  computed: {
    ...mapGetters({
      bookings: "booking/getBookings",
      countAreaBooking: "booking/countAreaBooking",
      countBookingsSuccess: "booking/countBookingsSuccess"
    }),
    currentBookings() {
      let bookingsOb = {
        notCancelled: [],
        cancelled: []
      };
      if (this.bookings && this.bookings.length)
        for (const booking of this.bookings) {
          if (booking.status == "cancelled") bookingsOb.cancelled.push(booking);
          else bookingsOb.notCancelled.push(booking);
        }
      return bookingsOb;
    },
    currentHeader(){
      return this.headers && this.headers.length ? this.headers.filter(h => h.isShow) : []; // filter(h=>h.isShow == true)
    },
    userFullName() {
      return this.$store.getters["user/getFullName"];
    },
    admin() {
      return this.$store.getters["admin/getByMarketId"](this.marketId);
    },
    employee() {
      return this.$store.getters["employee/getByMarketId"](this.marketId);
    },
  },

  data() {
    return {
      projectId: this.$route.params.projectId,
      marketId: this.$route.params.marketId,
      project: null,
      market: null,
      selected: [],
      headers: [],
      isLoading: false,
      detailDialog: false,
      currentBooking: null,
      isInvoiceDialog: false,
      currentInvoiceId: "",
      currentBookingId: "",
      startDate: this.$moment()
        .startOf("month")
        .format("YYYY-MM-DD"),
      endDate: this.$moment()
        .endOf("month")
        .format("YYYY-MM-DD"),
      itemsPerPage: 10
    };
  },
  created() {
    if (this.admin) {
      this.project = this.admin.project;
      this.market = this.admin.market;
    }
    if (this.employee) {
      this.project = this.employee.project;
      this.market = this.employee.market;
    }

    this.headers = [
        {
          text: this.$t('booking.booking_number'),
          align: "center",
          value: "documentId"
        },
        {
          text: this.$t('booking.date_booking'),
          align: "center",
          value: "createdAtFormat"
        },
        {
          text: this.$t('booking.booking_channel'),
          align: "center text-no-wrap",
          value: "bookingChannel.name",
          class: 'text-no-wrap',
          sortable: false,
        },
        {
          text: this.$t('contract.business_name'),
          align: "center hd-resize area-name",
          value: "businessName",
          sortable: false,
        },
        {
          text: this.$t('booking.booker_name'),
          align: "center hd-resize area-name",
          value: "customerName",
          sortable: false,
        },
        {
          text: this.$t('area.stall_list'),
          align: "center hd-resize area-name",
          value: "areaNames",
          sortable: true,
          class: "custom-sort"
        },
        {
          text: this.$t('area.enter_stall'),
          align: "center",
          value: "countCheckIn"
        },
        {
          text: this.$t('status'),
          align: "center",
          value: "statusText"
        },
        {
          text: this.$t('payment.paid'),
          align: "right",
          value: "sumTotalPaidValue"
        },
        {
          text: this.$t('payment.pending'),
          align: "right",
          value: "sumTotalUnpaidValue"
        },
        {
          text: this.$t('payment.total_price'),
          align: "right",
          value: "sumTotalValue"
        },
        {
          text: "",
          align: "center",
          value: "detail"
        }
    ];
  },
  mounted() {
    this.intiDataTable()
    this.initData();
  },
  watch: {
    detailDialog(value) {
      if (!value) {
        this.currentBooking = null;
        this.currentInvoiceId = "";
        this.currentBookingId = "";
      }
    }
  },
  methods: {
    intiDataTable() {
      if (this.headers && this.headers.length) {
        for (let header of this.headers) {
          if (header.isShow === undefined) header.isShow = true
          else header.isShow = false
        }
      }
      this.onSelectFilterColumn(this.headers.filter(h => h.isShow).map(h => h.value))
    },
    onSelectFilterColumn(hs) {
      let resHeaders = []
      let hst = []
      let filterDataTable = localStorage.getItem("filterDataTable");
      filterDataTable = filterDataTable ? JSON.parse(filterDataTable) : null
      let lhs = filterDataTable && filterDataTable['ReportBooking'] ? filterDataTable['ReportBooking'] : null
      if (lhs && lhs.length) hst = lhs
      else if (hs) hst = hs
      for (let header of this.headers) {
        header.isShow = hst.find(h => h == header.value) ? true : false;
        resHeaders.push(header)
      }
      this.headers = resHeaders
    },
    async initData(date) {
      this.isLoading = true;
      this.selected = [];
      await this.$store.dispatch("booking/getBookingBetweenDateByMarket", {
        marketId: this.$route.params.marketId || this.marketId,
        type: this.bookingType,
        startDate: date
          ? date.startDate
          : this.$moment(this.startDate).toISOString(),
        endDate: date ? date.endDate : this.$moment(this.endDate).toISOString()
      });
      if(date){
        this.startDate = this.$moment(date.startDate).format("YYYY-MM-DD")
        this.endDate = this.$moment(date.endDate).format("YYYY-MM-DD")
      }
      if (this.currentBookingId) {
        this.currentBooking = await this.$store.dispatch(
          "booking/getBooking",
          this.currentBookingId
        );
      }
      this.isLoading = false;
    },
    async exportExcel() {
      let exportItems = [];
      if (
        this.currentBookings.notCancelled &&
        this.currentBookings.notCancelled.length
      )
        exportItems = exportItems.concat(this.currentBookings.notCancelled);
      if (
        this.currentBookings.cancelled &&
        this.currentBookings.cancelled.length
      )
        exportItems = exportItems.concat(this.currentBookings.cancelled);
      try {
        await ExportMarketReport.exportMarketBookingReportByMarket(
          exportItems,
          this.bookingType,
          this.startDate,
          this.endDate
        );
      } catch (e) {
        console.log(e);
      }
    },
    clickDetail(booking) {
      this.detailDialog = true;
      this.currentBooking = booking;
      this.currentBookingId = booking.objectId;
    },
    openInvoice(invoiceId) {
      this.currentInvoiceId = invoiceId;
      this.isInvoiceDialog = true;
    },
    onSaveSuccess() {
      this.initData();
    },
    sumField(data, key, key2) {
      if (data && data.length && key && key2)
        return data.reduce((a, b) => a + (b[key] * b[key2] || 0), 0);
      else if (data && data.length && key && !key2)
        return data.reduce((a, b) => a + (b[key] || 0), 0);
      else return 0;
    },
    createBookingSuccess(booking) {
      if (booking) {
        // this.currentBooking = booking;
        this.currentBookingId = booking.objectId;
      }
      this.initData();
    },
    printPDF() {
      const tempItemsPerPage = this.itemsPerPage
      this.itemsPerPage = -1
      setTimeout(() => {
        let printarea = document.getElementById("printarea").innerHTML;
        let printPreviewTopic = document.getElementById("print-preview-topic");
        let printPreviewcontent = document.getElementById("print-preview-content");
        let printPreviewFooter = document.getElementById("print-preview-footer");
        printPreviewTopic.innerHTML = `
          <h2 style="text-align: center;" class="my-4">
            <b>${this.bookingType == 'daily' ? this.$t('booking.booking_daily') : this.bookingType == 'monthly' ? this.$t('booking.booking_monthly') : '-'}</b>
          </h2>
          <p style="text-align: center;">${this.market.name}</p>
          <p style="text-align: center;">
            ${this.$moment(this.startDate, "YYYY-MM-DD").format("D MMMM YYYY")} - ${this.$moment(this.endDate, "YYYY-MM-DD").format("D MMMM YYYY")}
          </p>
        `
        printPreviewcontent.innerHTML = printarea
        printPreviewFooter.innerHTML = `<div style="text-align: right;"><b>${this.$t('print_by')} : </b>${this.userFullName} <b>${this.$t('when')}</b> ${this.$moment().format("lll")}</div>`
        window.print();
        this.itemsPerPage = tempItemsPerPage
      }, 200)
    }
  }
};
</script>

<style lang="scss" scoped>
.booking-box,
.booking-box-non {
  border: 1px solid rgba(128, 128, 128, 0.2);
  padding: 10px 15px;
  margin: 0px 0 10px;
  align-items: center;
}

.booking-box:hover {
  background: rgba(128, 128, 128, 0.05);
  cursor: pointer;
}

.payment-box {
  border: 1px solid rgba(128, 128, 128, 0.5);
  padding: 10px 15px;
  margin: 0px 20px;
  align-items: center;
}

.data-table-booking::v-deep td {
  max-width: 200px;
}

.data-table-booking::v-deep td.hd-resize {
  max-width: 100px;
}

.data-table-booking::v-deep td.hd-resize.area-name {
  max-width: 80px;
}

.data-table-booking::v-deep th.custom-sort {
  position: relative;
  .v-icon{
    position: absolute;
    right: 24px;
    top: 18px;
  }
}
</style>